import React from 'react'
import {
	Flex500Logo,
	Muvi1000Logo,
	Super2000Logo,
	Top4000Logo,
	Lux8000Logo
} from '.'

export const PlansLogoRouter = ({ id, fontSize }) => {
	switch (id) {
		case 1:
			return <Flex500Logo fontSize={fontSize} />

		case 2:
			return <Muvi1000Logo fontSize={fontSize} />

		case 3:
			return <Super2000Logo fontSize={fontSize} />

		case 4:
			return <Top4000Logo fontSize={fontSize} />

		case 5:
			return <Lux8000Logo fontSize={fontSize} />

		default:
			return null
	}
}
